import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import ViewTitle from '../../common/view-title';
import ScannerPaylocityDesktop from './scanner-paylocity-desktop';
import ScannerPaylocityMobile from './scanner-paylocity-mobile';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        paddingBottom: 20
    }
}));

const ScannerPaylocity = () => {

    const classes = useStyles();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

    useEffect(() => {
        window.document.title = 'Paylocity Scanner';

        window.addEventListener('resize', handleWindowSize);

        return () => window.removeEventListener('resize', handleWindowSize);
    }, []);

    const handleWindowSize = () => setIsMobile(window.innerWidth < 500);

    return (
        <div className={classes.root}>
            <ViewTitle title='Paylocity Scanner' sedeFlag />

            {isMobile ? <ScannerPaylocityMobile alone={true} /> : <ScannerPaylocityDesktop/>}
        </div>
    );
}

export default ScannerPaylocity;